const URLS = window.MEALAGENT_URLS;
export default URLS;
